module.exports = __webpack_public_path__ + "img/b3-2.434b389.png";